import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useHorizontalScroll } from "../../Helpers/useSideScroll";
import { ApiContext } from "../ApiContext";
import { BackdropLoading } from "../Common/BackdropLoading";
import { UserContext } from "../UserContext";


import { ReactComponent as ToolsIcon } from "../../Assets/Icons/ToolsIcon.svg";
import { ColorScheme } from "../../Themes/ColorScheme";
import { LocationCard } from "./LocationCard";

export const ListLocations = () => {
	const debug = false;

	const { handleTitle, user } = useContext(UserContext);

	const [locations, setLocations] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [serverError, setServerError] = useState(false);
	const [noLocations, setNoLocations] = useState(false);

	const { ApiCall } = useContext(ApiContext);
	const ref = useHorizontalScroll();
	const { t } = useTranslation();

	const getLocations = (route) => {
		setIsLoading(true);

		ApiCall("GET", route, null, null)
			.then((res) => {
				if (res.length < 1) setNoLocations(true);
				else setNoLocations(false);
				setLocations(res);
			})
			.catch((err) => {
				setServerError(true);
				if (debug) console.log(err);
			});
	};

	useEffect(() => {
		handleTitle(t("common.locations"));
		setNoLocations(false);
		setServerError(false);
		if (locations.length < 1 && user?.name !== undefined)
			getLocations("client/locations");
	}, [user]);

	useEffect(() => {
		// force loading animation to show up while fetching and processing data
		if (locations.length > 0 || noLocations || serverError)
			setIsLoading(false);
	}, [locations, noLocations, serverError]);

	return (
		<Box>
			<Stack
				spacing={2}
				sx={{ alignItems: isMobile ? "center" : undefined }}
			>
				{isLoading && <BackdropLoading />}
				{!isLoading && locations.length < 1 && (
					<>
						{serverError && (
							<Box textAlign="center" sx={{ padding: "10%" }}>
								<ToolsIcon stroke={ColorScheme.secondary} />
								<div style={{ height: "25px" }} />
								<Typography>
									{t("location.no_proper_response")}
								</Typography>
							</Box>
						)}
						{noLocations && !serverError && (
							<Typography
								sx={{
									fontSize: "20px",
									fontWeight: "700",
									color: ColorScheme.white,
									textAlign: isMobile ? "center" : undefined
								}}
							>
								{t("location.no_locations_found")}
							</Typography>
						)}
					</>
				)}
				{locations.length < 4 && (
					<Box
						ref={ref}
						style={{
							flexDirection: !isMobile ? "row" : "column",
							display: "flex",
							overflowX: !isMobile ? "scroll" : "none",
							overflowY: !isMobile ? "none" : "scroll",
							flex: 1,
							padding: !isMobile && "20px",
							width: "100%"
						}}
					>
						{locations.map((location) => (
							<LocationCard
								isCard={locations.length < 4 && !isMobile}
								key={location.id}
								data={location}
								getLocations={getLocations}
							/>
						))}
					</Box>
				)}
				{locations.length > 3 && (
					<Box
						sx={{
							flexDirection: "column",
							display: "flex",
							overflowX: "none",
							overflowY: "scroll",
							flex: 1,
							gap: "15px",
							width: "100%"
						}}
					>
						{locations.map((location) => (
							<LocationCard
								key={location.id}
								data={location}
								getLocations={getLocations}
							/>
						))}
					</Box>
				)}
			</Stack>
		</Box>
	);
};
